// extracted by mini-css-extract-plugin
module.exports = {"container":"CreateAccount_container__2ugPy"};